import { render, staticRenderFns } from "./BotaoAdicionarSalaEspera.vue?vue&type=template&id=4c10ded2&scoped=true"
import script from "./BotaoAdicionarSalaEspera.vue?vue&type=script&lang=js"
export * from "./BotaoAdicionarSalaEspera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c10ded2",
  null
  
)

export default component.exports